module.exports = __webpack_public_path__ + "img/no_coupon_2.0649e173.png";